import * as _ from 'underscore';

import { ReactDirectiveSpec } from '../../ts/directives/reactDirectiveFactory';
import { Helpers } from '../../ts/helpers/Helpers';
import { getCapabilityValuesSectionComponent, PermissionType } from './PermissionsCapabilityValues';
import {
  getDatabaseSectionGroups,
  getDataRoleSectionGroups,
  getDatasourceSectionGroups,
  getFlowSectionGroups,
  getProjectSectionGroupsWithFlowsAndDataRoles,
  getTableSectionGroups,
  getViewSectionGroups,
  getWorkbookSectionGroups,
  Section,
  SectionGroup
} from './SectionGroups';

function getCapabilityValueDirectiveNameForSection(contentType: string, sectionLocKey: string, permissionType: PermissionType) {
  const snakeCaseName = `tb-permissions-${permissionType}-${contentType}-${sectionLocKey}-capability-values`;
  return Helpers.makeAngularDirectiveName(snakeCaseName);
}

const sectionGroups: ReadonlyArray<SectionGroup> = _.flatten([
  // Flows/DataRoles is controlled by a feature flag. We register the section group directives for flows,
  // but the Pug template is switched on this flag and will instantiate only those that it needs.
  getProjectSectionGroupsWithFlowsAndDataRoles(),
  getWorkbookSectionGroups(),
  getViewSectionGroups(),
  getDatasourceSectionGroups(),
  getFlowSectionGroups(),
  getDataRoleSectionGroups(),
  getTableSectionGroups(),
  getDatabaseSectionGroups(),
]);

export const PermissionsDirectives: ReadonlyArray<ReactDirectiveSpec> = (function() {

  const directives: ReactDirectiveSpec[] = [];

  for (const permissionType of _.values(PermissionType)) {
    for (const sectionGroup of sectionGroups) {
      sectionGroup.sections.forEach((section: Section, sectionNumber: number) => {
        const contentType = sectionGroup.name;
        const sectionName = section.locKey;
        const directiveName = getCapabilityValueDirectiveNameForSection(contentType, sectionName, permissionType);

        directives.push({
          name: directiveName,
          component: getCapabilityValuesSectionComponent({contentType, sectionGroup, sectionNumber, permissionType})
        });
      });
    }
  }

  return directives;
})();
